
import React from "react";
import { Table, TableBody, TableCell, TableRow } from "../../../components/ui/table";
import  { OnePageCustomerSession }  from "../../../types/CustomerInterface";

type CompanyProfileSectionProps = {
  company_details?: OnePageCustomerSession; // Example prop
};



export const CompanyProfileSection: React.FC<CompanyProfileSectionProps> = ({company_details }) => {
  const companyDetails = [
    { label: "Legal Entity Name", value: company_details?.legal_name ?? "-" },
    { label: "Brand Name", value: company_details?.brand ?? "-" },
    { label: "Website", value: company_details?.website ?? "-" },
    { label: "Entity Type", value: company_details?.entity_type ?? "-" },
    { label: "Share Price", value: "-" },
    { label: "Market Cap", value: "-" },
    { label: "Group Company", value: "-" },
    { label: "Proposed Facility", value: "-" },
    { label: "Proposed Quantum", value: "-" },
    { label: "Proposed Collateral", value: "-" },
    { label: "PAN", value: company_details?.pan ?? "-" },
    { label: "CIN/LLPIN", value: company_details?.cin ?? "-" },
    {
      label: "City, State",
      value: company_details?.city && company_details?.state
        ? `${company_details.city}, ${company_details.state}`
        : company_details?.city ?? company_details?.state ?? "-"
    },
    { label: "Registered Address", value: company_details?.registered_address ?? "-" },
    { label: "Incorporation Date", value: company_details?.incorporation_date ?? "-" },
    {
      label: "Turnover",
      value:
        company_details?.turnoverYear && company_details?.turnoverValue
          ? `${company_details.turnoverYear}, ${company_details.turnoverValue}`
          : "-"
    },
    {
      label: "Networth",
      value:
        company_details?.networthYear && company_details?.networthValue
          ? `${company_details.networthYear}, ${company_details.networthValue}`
          : "-"
    },
    { label: "Credit Rating", value: company_details?.creditRating ?? "-" },
    { label: "Credit Rating Agency", value: company_details?.creditRatingAgency ?? "-" }
  ];

  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">1</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Company Details</h3>
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table>
          <TableBody>
            {companyDetails.map((detail, index) => (
              <TableRow key={index} className="hover:bg-gray-50">
                <TableCell className="font-medium bg-gray-50 w-1/3">{detail.label}</TableCell>
                <TableCell className={detail.label === "Group Details" || detail.label === "Registered Address" ? "text-sm leading-relaxed" : ""}>
                  {detail.value}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
